import {
  BooleanField,
  CreateButton,
  Datagrid,
  List,
  ReferenceField,
  ReferenceInput,
  SelectInput,
  TextField,
  TopToolbar,
} from 'react-admin';

const cityFilters = [
  <ReferenceInput key="state" source="state_id" reference="states" label="State" alwaysOn>
    <SelectInput optionText="name" />
  </ReferenceInput>,
];

const ListActions = () => (
  <TopToolbar>
    <CreateButton />
  </TopToolbar>
);

export function CityList() {
  return (
    <List
      actions={<ListActions />}
      filters={cityFilters}
      sort={{ field: 'name', order: 'ASC' }}
      perPage={50}
    >
      <Datagrid rowClick="edit">
        <TextField source="name" />
        <TextField source="slug" />
        <ReferenceField source="state_id" reference="states" label="State">
          <TextField source="name" />
        </ReferenceField>
        <BooleanField source="is_active" label="Active" />
      </Datagrid>
    </List>
  );
}
